import { useState } from "react";
import { Quote, Copy, Check } from "lucide-react";
import { toast } from "@/hooks/use-toast";

interface Props {
  title: string;
  path: string;
  datePublished?: string;
}

export const CiteThisArticle = ({ title, path, datePublished }: Props) => {
  const [copied, setCopied] = useState(false);
  const year = datePublished ? new Date(datePublished).getFullYear() : "n.d.";
  const url = `https://davidisei.com${path}`;
  const apa = `Isei, D. (${year}). ${title}. David Isei. ${url}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(apa);
      setCopied(true);
      toast({ title: "Citation copied" });
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast({ title: "Copy failed", variant: "destructive" });
    }
  };

  return (
    <details className="mt-10 rounded-md border border-border/40 bg-card/30">
      <summary className="cursor-pointer px-4 py-3 text-[11px] uppercase tracking-[0.22em] text-accent font-semibold flex items-center gap-2 hover:bg-card/50 transition-colors rounded-md">
        <Quote className="h-3 w-3" />
        Cite this article
      </summary>
      <div className="px-4 pb-4 space-y-3">
        <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">APA Format</p>
        <p className="text-sm text-foreground font-mono leading-relaxed bg-background/60 p-3 rounded border border-border/40">
          {apa}
        </p>
        <button
          onClick={copy}
          className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] px-2.5 py-1.5 rounded-md border border-border/50 text-muted-foreground hover:text-foreground hover:border-accent/60 transition-colors"
        >
          {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
          {copied ? "Copied" : "Copy citation"}
        </button>
      </div>
    </details>
  );
};

export default CiteThisArticle;
